import React from 'react';
interface GlassInputProps {
  type?: 'text' | 'email' | 'password' | 'number' | 'date';
  placeholder?: string;
  value: string | number;
  onChange: (value: string) => void;
  label?: string;
  required?: boolean;
  min?: number;
  step?: number;
}
export function GlassInput({
  type = 'text',
  placeholder,
  value,
  onChange,
  label,
  required = false,
  min,
  step
}: GlassInputProps) {
  return <div className="space-y-2" data-id="element-39">
      {label && <label className="block text-sm font-medium text-white/90" data-id="element-40">
          {label}
        </label>}
      <input type={type} placeholder={placeholder} value={value} onChange={e => onChange(e.target.value)} required={required} min={min} step={step} className={`px-4 py-3 rounded-2xl backdrop-blur-xl bg-white/20 border border-white/30 text-white placeholder-white/50 focus:outline-none focus:ring-2 focus:ring-white/50 focus:border-white/50 transition-all ${type === 'date' ? 'w-auto' : 'w-full'}`} data-id="element-41" />
    </div>;
}